import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import { IPncpPurchaseContractDetailResponse } from '../../../model/base/response/pncp-purchase-contract-detail-response';

interface PncpPurchaseContractDetailState {
  contract: IPncpPurchaseContractDetailResponse | null;
  loading: boolean;
  error: string | null;
}

type PncpPurchaseContractDetailAction =
  | { type: 'LOAD_START' }
  | { type: 'LOAD_SUCCESS'; payload: IPncpPurchaseContractDetailResponse }
  | { type: 'LOAD_ERROR'; payload: string };

const initialState: PncpPurchaseContractDetailState = {
  contract: null,
  loading: false,
  error: null,
};

const PncpPurchaseContractDetailStateContext = createContext<PncpPurchaseContractDetailState | undefined>(undefined);
const PncpPurchaseContractDetailDispatchContext = createContext<React.Dispatch<PncpPurchaseContractDetailAction> | undefined>(undefined);

function pncpPurchaseContractDetailReducer(state: PncpPurchaseContractDetailState, action: PncpPurchaseContractDetailAction): PncpPurchaseContractDetailState {
  switch (action.type) {
    case 'LOAD_START':
      return { ...state, loading: true, error: null };
    case 'LOAD_SUCCESS':
      return { ...state, loading: false, contract: action.payload };
    case 'LOAD_ERROR':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

export function PncpPurchaseContractDetailProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(pncpPurchaseContractDetailReducer, initialState);

  return (
    <PncpPurchaseContractDetailStateContext.Provider value={state}>
      <PncpPurchaseContractDetailDispatchContext.Provider value={dispatch}>
        {children}
      </PncpPurchaseContractDetailDispatchContext.Provider>
    </PncpPurchaseContractDetailStateContext.Provider>
  );
}

export function usePncpPurchaseContractDetailState() {
  const context = useContext(PncpPurchaseContractDetailStateContext);
  if (context === undefined) {
    throw new Error('usePncpPurchaseContractDetailState must be used within a PncpPurchaseContractDetailProvider');
  }
  return context;
}

export function usePncpPurchaseContractDetailDispatch() {
  const context = useContext(PncpPurchaseContractDetailDispatchContext);
  if (context === undefined) {
    throw new Error('usePncpPurchaseContractDetailDispatch must be used within a PncpPurchaseContractDetailProvider');
  }
  return context;
}
